export const pageBordereau = (state) => state.pageBordereau;
export const pageFacture = (state) => state.pageFacture;
export const pageContrat = (state) => state.pageContrat;
export const pageTier = (state) => state.pageTier;
export const pageMarche = (state) => state.pageMarche;
export const pageCommande = (state) => state.pageCommande;
export const pageOd = (state) => state.pageOd;
export const pageMission = (state) => state.pageMission;
export const pageAutreDocumentComptable = (state) =>
  state.pageAutreDocumentComptable;
export const title = (state) => state.title;
